type Conversion = 'sign_up' | 'login' | 'league_application_submitted' | 'league_discovery_started'
  | 'feed_player_opened' | 'feed_match_opened' | 'feed_refreshed' | 'feed_position_restored' | 'feed_incoming_shown'
  | 'feed_view_home' | 'feed_view_league' | 'feed_congrats' | 'feed_share' | 'feed_rematch_opened'
  | 'feed_return_congrats' | 'feed_login_to_congrats' | 'feed_match_request' | 'feed_open_from_push'
  | 'feed_match_cheer' | 'feed_partner_offer' | 'feed_partner_open' | 'feed_weekly_match_open' | 'feed_notes_open'
  | 'app_install_prompt' | 'app_install_accepted' | 'app_install_guide' | 'app_installed'
  | 'android_welcome_shown' | 'android_welcome_install' | 'android_welcome_push';

// No search terms, player IDs, names, email addresses or phone numbers.
// Uses the site's existing analytics setup; does not create a new tracker.
export function trackConversion(name: Conversion, method?: 'password' | 'google') {
  if (typeof window === 'undefined' || process.env.NODE_ENV !== 'production' || !process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS) return;
  // eslint-disable-next-line no-unused-vars -- Parameter name is part of a function type.
  const gtag = (window as Window & { gtag?: (...args: unknown[]) => void }).gtag;
  gtag?.('event', name, method ? { method } : {});
}
